import type { Month } from "./supabase.types.gen";

export const monthToNumberMap: Record<Month, number> = {
  january: 1,
  february: 2,
  march: 3,
  april: 4,
  may: 5,
  june: 6,
  july: 7,
  august: 8,
  september: 9,
  october: 10,
  november: 11,
  december: 12,
};

/**
 * Reverse map: number (1-based) → Month enum
 * Generated from monthToNumberMap for maintainability
 */
export const numberToMonthMap: Record<number, Month> = Object.fromEntries(
  Object.entries(monthToNumberMap).map(([month, number]) => [number, month])
) as Record<number, Month>;
